import React, { useRef, useEffect } from 'react';

export const AuthIframe = ({ token, authHandler }) => {
  const authIframeRef = useRef(null);
  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.data.reason === 'TOKEN') {
        const data = event.data.message;
        if (!data) {
          window.location.href = `${window.location.origin}/logout`;
        } else {
          authHandler(data.token, data.dmToken);
        }
      } else if (event.data.reason === 'IFRAME_READY') {
        requestAuthToken();
      }
    });
  }, []);
  const requestAuthToken = () => {
    authIframeRef?.current?.contentWindow?.postMessage(
      { reason: 'VERIFY_AUTH', message: token },
      '*'
    );
  };
  return (
    <>
      <iframe
        title="Authentication"
        sandbox="allow-modals allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox allow-downloads allow-top-navigation"
        frameBorder={0}
        src={process.env.REACT_APP_IBL_SPA_AUTH_URL}
        style={{ width: 0 }}
        allowFullScreen={false}
        ref={authIframeRef}
        onLoad={() => requestAuthToken()}
      ></iframe>
    </>
  );
};
